import request from '../request'

export default {
  getIncendios: () => {
    return request.get('incendios')
  },
  getIncendiosFiltered: (rango) => {
    const [ini, fin] = rango
    return request.get('incendios_filtered', {
      params: {
        from: new Date(ini).toISOString(),
        to: new Date(fin).toISOString()
      }
    })
  },
  getIncendiosReduced: () => {
    return request.get('incendios_reduced')
  },
  getIncendioById: (id) => {
    return request.get(`incendio_id/${id}`)
  },
  getTiposIncendioEstado() {
    return request.get('tipo_incendio_estado')
  },
  getTiposIncendioNivel() {
    return request.get('tipo_incendio_nivel')
  },

  getTiposDeteccion() {
    return request.get('tipo_deteccion')
  },

  addIncendio(data) {
    return request.post('incendio', data)
  },
  editIncendio(data) {
    return request.put(`incendio_id/${data.ID_INCENDIO}`, data)
  },
  ocultarIncendio(data) {
    return request.put(`ocultar_incendio/${data.ID_INCENDIO}/${data.OCULTO}`)
  },

  addNivelIncendio(data) {
    return request.post('incendio_nivel', data)
  },

  deleteNivelIncendio(data) {
    return request.delete('incendio_nivel', { data })
  },
  editNivelIncendio(data) {
    return request.put('incendio_nivel', data)
  },
  addEstadoIncendio(data) {
    return request.post('incendio_estado', data)
  },
  editEstadoIncendio(data) {
    return request.put('incendio_estado', data)
  },
  deleteEstadoIncendio(data) {
    return request.delete('incendio_estado', { data })
  },

  changeSectoresIncendio(data) {
    return request.put(`sector/${data.ID_INCENDIO}`, data)
  },

  addMediosIncendio(data) {
    return request.post('medio_sector', data)
  },
  editMedioIncendio(data) {
    return request.put(`medio_sector/${data.ID_MEDIO_SECTOR}`, data)
  },
  deleteMedioIncendio(data) {
    return request.delete(`medio_sector/${data.ID_MEDIO_SECTOR}`, { data })
  },

  editPlanificacionMedio(data) {
    return request.put(`planificacion_medio/${data.PLANIFICACION.ID_PLANIFICACION_MEDIO}`, data.PLANIFICACION)
  },

  addPlanOperaciones(data) {
    return request.post('plan_operaciones', data)
  },
  editPlanOperaciones(data) {
    return request.put(`plan_operaciones/${data.ID_PLAN_OPERACIONES}`, data)
  },
  deletePlanOperaciones(data) {
    return request.delete(`plan_operaciones/${data.ID_PLAN_OPERACIONES}`)
  },
  editAlineacionesCampbell(data) {
    return request.put(`alineaciones_campbell/${data.ID_ALINEACIONES_CAMPBELL}`, data)
  },

  addPerimetro(data) {
    return request.post('perimetro', data)
  },
  editPerimetro(data) {
    return request.put(`perimetro/${data.ID_PERIMETRO}`, data)
  },
  deletePerimetro(data) {
    return request.delete(`perimetro/${data.ID_PERIMETRO}`)
  },
  addImportedPerimetro(data) {
    return request.post('perimetro/addImportedPerimetro', data)
  }
}
